import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=84d3e5f2"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d3e5f2')) {
      api.createRecord('84d3e5f2', component.options)
    } else {
      api.reload('84d3e5f2', component.options)
    }
    module.hot.accept("./Skills.vue?vue&type=template&id=84d3e5f2", function () {
      api.rerender('84d3e5f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/skill/Skills.vue"
export default component.exports